﻿/**
 * 缁忓吀 Variant Selector
 * 鐩戝惉閫夐」鍙樺寲 鈫?鍖归厤 variant 鈫?鏇存柊 UI
 */

if (!customElements.get('variant-selector')) {
  customElements.define(
    'variant-selector',
    class VariantSelector extends HTMLElement {
      constructor() {
        super();

        // 瑙ｆ瀽 variants JSON
        this.variants = this.parseJSONScript('[data-variants-json]', []);
        this.optionKeys = this.parseJSONScript('[data-option-keys]', []);
        this.productVideo = this.parseJSONScript('[data-product-video]', null);
        this.currentVariant = this.enrichVariantData(
          this.parseJSONScript('[data-current-variant]', null)
        );

        const variantResources = this.parseJSONScript('[data-variant-resources]', null);
        this.variantImageMap = {};
        this.variantMediaMap = null;

        if (variantResources && typeof variantResources === 'object') {
          this.variantMediaMap = {};

          Object.entries(variantResources).forEach(([variantId, resource]) => {
            this.variantImageMap[variantId] = resource?.image || null;
            this.variantMediaMap[variantId] = Array.isArray(resource?.mediaIds) ? resource.mediaIds : [];
          });
        } else {
          this.variantImageMap = this.parseJSONScript('[data-variant-image-map]', {});

          // 瑙ｆ瀽鍥剧墖涓?variant 鐨勫叧鑱斿叧绯?
          this.variantMediaMap = this.parseJSONScript('[data-variant-media-map]', null);
        }

        this.variantOptionIndex = this.buildVariantOptionIndex();

        // 缂撳瓨 DOM 鍏冪礌
        this.sectionId = this.dataset.section;
        this.productUrl = this.dataset.url;
        
        // 鏄惁鍚敤璺宠浆妯″紡锛坉ata-redirect="true"锛?
        this.redirectOnChange = this.dataset.redirect === 'true';
      }

      connectedCallback() {
        this.addEventListener('change', this.onOptionChange.bind(this));
        
        // 鍒濆鍖栬仈鍔ㄧ姸鎬?
        const selectedOptions = this.getSelectedOptions();
        this.updateOptionAvailability(selectedOptions);
        this.updateOptionSwatches(selectedOptions);

        if (this.currentVariant) {
          this.updateMedia(this.currentVariant);
        }
      }

      /**
       * 閫夐」鍙樺寲鏃惰Е鍙?
       */
      onOptionChange(event) {
        // 鏇存柊鏄剧ず鐨勯€変腑鍊?
        this.updateSelectedValueDisplay(event.target);

        // 鑾峰彇褰撳墠鎵€鏈夐€変腑鐨勯€夐」
        const selectedOptions = this.getSelectedOptions();

        // 鏇存柊鍏朵粬閫夐」鐨勫彲鐢ㄧ姸鎬侊紙鑱斿姩锛?
        this.updateOptionAvailability(selectedOptions);
        this.updateOptionSwatches(selectedOptions);

        // 鏍规嵁閫夐」鍖归厤 variant
        const matchedVariant = this.findVariantByOptions(selectedOptions);

        if (matchedVariant) {
          this.currentVariant = this.enrichVariantData(matchedVariant);
          this.updateAll(this.currentVariant);
        } else {
          // 娌℃湁鍖归厤鐨?variant锛堢粍鍚堜笉瀛樺湪锛?
          this.setUnavailable();
        }
      }

      /**
       * 鏇存柊閫変腑鍊肩殑鏄剧ず鏂囨湰
       */
      updateSelectedValueDisplay(input) {
        const fieldset = input.closest('fieldset');
        const selectedValueEl = fieldset.querySelector('[data-selected-value]');
        if (selectedValueEl) {
          selectedValueEl.textContent = input.value;
        }
      }

      /**
       * 鑾峰彇褰撳墠閫変腑鐨勬墍鏈夐€夐」鍊?
       * @returns {Array} [option1, option2, option3]
       */
      getSelectedOptions() {
        const options = [];
        this.querySelectorAll('fieldset').forEach((fieldset, index) => {
          const checked = fieldset.querySelector('input:checked');
          options[index] = checked ? checked.value : null;
        });
        return options;
      }

      /**
       * 鏍规嵁閫夐」鍊兼暟缁勬壘鍒板尮閰嶇殑 variant
       * @param {Array} options - [option1, option2, option3]
       * @returns {Object|null} - 鍖归厤鐨?variant 鎴?null
       */
      findVariantByOptions(options) {
        return this.variants.find((variant) => {
          return options.every((option, index) => {
            // option1 瀵瑰簲 index 0锛屼互姝ょ被鎺?
            return variant[`option${index + 1}`] === option;
          });
        });
      }

      buildVariantOptionIndex() {
        const index = new Map();

        this.variants.forEach((variant) => {
          for (let optionIndex = 0; optionIndex < 3; optionIndex += 1) {
            const optionValue = variant[`option${optionIndex + 1}`];
            if (optionValue === null || optionValue === undefined) continue;

            const key = `${optionIndex}:${optionValue}`;
            if (!index.has(key)) {
              index.set(key, []);
            }
            index.get(key).push(variant);
          }
        });

        return index;
      }

      parseJSONScript(selector, fallback = null) {
        const script = this.querySelector(selector);
        if (!script) return fallback;

        try {
          return JSON.parse(script.textContent);
        } catch (error) {
          // Error handled silently in production - JSON parse failed
          return fallback;
        }
      }

      normalizeOptionKey(value) {
        return String(value || '')
          .toLowerCase()
          .trim()
          .replace(/[^a-z0-9]+/g, '-')
          .replace(/^-+|-+$/g, '');
      }

      normalizeOptionValue(value) {
        return String(value || '').toLowerCase().trim();
      }

      normalizeMediaAlt(value) {
        return String(value || '')
          .toLowerCase()
          .trim()
          .replace(/:\s*/g, '=')
          .replace(/\s*=\s*/g, '=')
          .replace(/[;,|]/g, ' ')
          .replace(/\s+/g, ' ');
      }

      buildVariantMediaMatchers(variant) {
        const optionValues = [variant?.option1, variant?.option2, variant?.option3]
          .map((value) => this.normalizeOptionValue(value))
          .filter(Boolean);

        const legacyKey = optionValues.join(' ').trim();
        const optionKeys = Array.isArray(this.optionKeys)
          ? this.optionKeys.map((value) => this.normalizeOptionKey(value))
          : [];

        const paramTokenGroups = [];

        optionValues.forEach((value, index) => {
          const tokens = [];
          const optionKey = optionKeys[index];

          if (optionKey) tokens.push(`${optionKey}=${value}`);
          if (index === 0) {
            tokens.push(`color=${value}`);
            tokens.push(`colour=${value}`);
          }

          paramTokenGroups.push(tokens.filter(Boolean));
        });

        return {
          legacyKey,
          paramTokenGroups,
        };
      }

      mediaAltMatchesVariant(altText, variant) {
        const normalizedAlt = this.normalizeMediaAlt(altText);
        if (!normalizedAlt) return false;

        const { legacyKey, paramTokenGroups } = this.buildVariantMediaMatchers(variant);

        if (legacyKey && (normalizedAlt === legacyKey || normalizedAlt.startsWith(`${legacyKey} `))) {
          return true;
        }

        if (paramTokenGroups.length === 0) return false;

        return paramTokenGroups.every((tokenGroup) => {
          if (!Array.isArray(tokenGroup) || tokenGroup.length === 0) return true;
          return tokenGroup.some((token) => normalizedAlt.includes(token));
        });
      }

      findMediaIdsFromDomByVariant(variant, sectionRoot = this.getSectionRoot()) {
        const mediaIds = [];
        const seen = new Set();

        sectionRoot
          .querySelectorAll('.vc-product__thumbnail, .vc-product__dot, [data-thumbnail-id], [data-target], [data-media-id]')
          .forEach((element) => {
            const rawId =
              element.dataset.mediaId || element.dataset.thumbnailId || element.dataset.target || '';
            const normalizedId = String(rawId).replace(`${this.sectionId}-`, '').trim();
            if (!normalizedId || seen.has(normalizedId)) return;

            const altText =
              element.querySelector('img[alt]')?.getAttribute('alt') ||
              element.getAttribute('aria-label') ||
              element.getAttribute('alt') ||
              '';

            if (!this.mediaAltMatchesVariant(altText, variant)) return;

            seen.add(normalizedId);
            mediaIds.push(normalizedId);
          });

        return mediaIds;
      }

      enrichVariantData(variant) {
        if (!variant) return null;

        const customVideo = this.productVideo || null;

        return {
          ...variant,
          customVideo,
          customVideoMediaId: customVideo?.mediaId || null,
          customVideoSrc: customVideo?.videoSrc || null,
        };
      }

      getVariantImageData(variant) {
        if (!variant) return null;
        return this.variantImageMap?.[variant.id] || this.variantImageMap?.[String(variant.id)] || null;
      }

      findVariantForOptionValue(optionIndex, optionValue, selectedOptions) {
        const key = `${optionIndex}:${optionValue}`;
        const candidates = this.variantOptionIndex.get(key) || [];
        if (candidates.length === 0) return null;

        const exactContextMatch = candidates.find((variant) => {
          return selectedOptions.every((selectedValue, selectedIndex) => {
            if (selectedIndex === optionIndex || selectedValue === null) return true;
            return variant[`option${selectedIndex + 1}`] === selectedValue;
          });
        });

        return exactContextMatch || candidates[0];
      }

      renderOptionSwatch(label, value, imageData) {
        if (!label) return;

        const visuallyHidden = label.querySelector('.visually-hidden');
        const existingSwatch = label.querySelector('.variant-selector__swatch');
        let textEl = label.querySelector('.variant-selector__text');

        label.title = value;

        if (imageData?.src) {
          label.classList.add('variant-selector__value-label--image');

          const swatch = existingSwatch || document.createElement('span');
          swatch.className = 'variant-selector__swatch';

          let img = swatch.querySelector('img[data-option-image]');
          if (!img) {
            swatch.innerHTML = '';
            img = document.createElement('img');
            img.setAttribute('data-option-image', '');
            img.loading = 'lazy';
            img.width = 50;
            img.height = 50;
            swatch.appendChild(img);
          }

          img.src = imageData.src;
          if (imageData.srcset) {
            img.srcset = imageData.srcset;
          } else {
            img.removeAttribute('srcset');
          }
          img.alt = value;

          if (!existingSwatch) {
            if (visuallyHidden) {
              label.insertBefore(swatch, visuallyHidden);
            } else {
              label.prepend(swatch);
            }
          }

          if (textEl) {
            textEl.remove();
          }
          return;
        }

        label.classList.remove('variant-selector__value-label--image');
        existingSwatch?.remove();

        if (!textEl) {
          textEl = document.createElement('span');
          textEl.className = 'variant-selector__text';
          if (visuallyHidden) {
            label.insertBefore(textEl, visuallyHidden);
          } else {
            label.prepend(textEl);
          }
        }

        textEl.textContent = value;
      }

      updateOptionSwatches(selectedOptions) {
        const fieldsets = this.querySelectorAll('fieldset');

        fieldsets.forEach((fieldset, optionIndex) => {
          const inputs = fieldset.querySelectorAll('input[type="radio"]');

          inputs.forEach((input) => {
            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            const swatchVariant = this.findVariantForOptionValue(optionIndex, input.value, selectedOptions);
            const imageData = this.getVariantImageData(swatchVariant);

            this.renderOptionSwatch(label, input.value, imageData);
          });
        });
      }

      /**
       * 鏇存柊閫夐」鐨勫彲鐢ㄧ姸鎬侊紙鑱斿姩閫昏緫锛?
       * 鏍规嵁褰撳墠閫変腑鐨勯€夐」锛岀鐢ㄤ笉瀛樺湪鐨勭粍鍚?
       */
      updateOptionAvailability(selectedOptions) {
        const fieldsets = this.querySelectorAll('fieldset');
        
        fieldsets.forEach((fieldset, optionIndex) => {
          const inputs = fieldset.querySelectorAll('input[type="radio"]');
          
          inputs.forEach(input => {
            const testOptions = [...selectedOptions];
            testOptions[optionIndex] = input.value;
            
            // 妫€鏌ヨ繖涓粍鍚堟槸鍚﹀瓨鍦?
            const variantExists = this.variants.some(variant => {
              return testOptions.every((opt, idx) => {
                if (opt === null) return true; // 杩樻病閫夌殑閫夐」璺宠繃
                return variant[`option${idx + 1}`] === opt;
              });
            });
            
            // 妫€鏌ユ槸鍚︽湁搴撳瓨
            const variantAvailable = this.variants.some(variant => {
              const matches = testOptions.every((opt, idx) => {
                if (opt === null) return true;
                return variant[`option${idx + 1}`] === opt;
              });
              return matches && variant.available;
            });
            
            const label = fieldset.querySelector(`label[for="${input.id}"]`);
            
            if (!variantExists) {
              // 缁勫悎涓嶅瓨鍦?
              input.disabled = true;
              if (label) {
                label.classList.add('variant-selector__option--unavailable');
                label.classList.remove('variant-selector__option--soldout');
              }
            } else if (!variantAvailable) {
              // 缁勫悎瀛樺湪浣嗘棤搴撳瓨
              input.disabled = false; // 鍏佽鐐瑰嚮鏌ョ湅
              if (label) {
                label.classList.add('variant-selector__option--soldout');
                label.classList.remove('variant-selector__option--unavailable');
              }
            } else {
              // 鍙敤
              input.disabled = false;
              if (label) {
                label.classList.remove('variant-selector__option--unavailable', 'variant-selector__option--soldout');
              }
            }
          });
        });
      }

      /**
       * 鏇存柊鎵€鏈夌浉鍏?UI
       */
      updateAll(variant) {
        this.updateURL(variant);
        this.updateVariantInput(variant);
        this.updatePrice(variant);
        this.updateInventory(variant);
        this.updateBuyButton(variant);
        const mediaState = this.updateMedia(variant);
        this.updateSKU(variant);
        this.publishVariantChange(variant, mediaState);

        // 鍙戝竷浜嬩欢锛屼緵鍏朵粬缁勪欢鐩戝惉
        this.dispatchEvent(
          new CustomEvent('variant:changed', {
            detail: { variant, ...mediaState },
            bubbles: true,
          })
        );
      }

      /**
       * 鏇存柊 URL
       * @param {Object} variant
       * @param {boolean} redirect - 鏄惁璺宠浆椤甸潰
       */
      updateURL(variant, redirect = false) {
        if (!variant) return;
        const url = `${this.productUrl}?variant=${variant.id}`;
        
        if (redirect || this.redirectOnChange) {
          // 璺宠浆鍒版柊椤甸潰
          window.location.href = url;
        } else {
          // 鍙洿鏂?URL 涓嶅埛鏂?
          window.history.replaceState({}, '', url);
        }
      }

      /**
       * 鏇存柊琛ㄥ崟涓殑 variant_id
       */
      updateVariantInput(variant) {
        const sectionRoot = this.getSectionRoot();
        const inputs = sectionRoot.querySelectorAll(
          `input[name="id"][form*="${this.sectionId}"], #product-form-${this.sectionId} input[name="id"]`
        );
        
        // 閫氱敤閫夋嫨鍣紝鏌ユ壘鏈€杩戠殑琛ㄥ崟
        if (inputs.length === 0) {
          const form = sectionRoot.querySelector(`form[id*="${this.sectionId}"], [data-type="add-to-cart-form"]`);
          if (form) {
            const input = form.querySelector('input[name="id"]');
            if (input) {
              input.value = variant.id;
              input.disabled = !variant.available;
            }
          }
        } else {
          inputs.forEach((input) => {
            input.value = variant.id;
            input.disabled = !variant.available;
          });
        }
      }

      /**
       * 鏇存柊浠锋牸鏄剧ず
       */
      updatePrice(variant) {
        const sectionRoot = this.getSectionRoot();
        const price = this.formatMoney(variant.price);
        const compareAtPrice = variant.compare_at_price
          ? this.formatMoney(variant.compare_at_price)
          : null;
        const isOnSale = Boolean(compareAtPrice && variant.compare_at_price > variant.price);

        const priceContainer = sectionRoot.querySelector(`#price-${this.sectionId}`) ||
                               sectionRoot.querySelector('.vc-product__price-wrapper .price') ||
                               sectionRoot.querySelector('.product__price, .price');

        if (priceContainer) {
          const saleEl = priceContainer.querySelector('.price__sale .price-item--sale') ||
                         priceContainer.querySelector('.price-item--sale');
          const compareSaleEl = priceContainer.querySelector('.price__sale .price-item--regular');
          const regularEl = priceContainer.querySelector('.price__regular .price-item--regular');

          if (saleEl) saleEl.textContent = price;
          if (regularEl) regularEl.textContent = price;

          if (isOnSale) {
            priceContainer.classList.add('price--on-sale');
            priceContainer.classList.remove('price--sold-out');
            if (compareSaleEl) compareSaleEl.textContent = compareAtPrice;
          } else {
            priceContainer.classList.remove('price--on-sale');
            if (compareSaleEl) compareSaleEl.textContent = '';
          }

          if (!variant.available) {
            priceContainer.classList.add('price--sold-out');
          } else {
            priceContainer.classList.remove('price--sold-out');
          }
        }

        const stickyPrice = sectionRoot.querySelector(
          `#vc-sticky-price-${this.sectionId}, .vc-product__sticky-price-amount`
        );
        if (stickyPrice) {
          stickyPrice.textContent = price;
        }

        const stickyCompare = sectionRoot.querySelector(
          `#vc-sticky-compare-${this.sectionId}, .vc-product__sticky-price-original`
        );
        if (stickyCompare) {
          if (isOnSale) {
            stickyCompare.textContent = compareAtPrice;
            stickyCompare.classList.remove('hidden');
          } else {
            stickyCompare.textContent = '';
            stickyCompare.classList.add('hidden');
          }
        }

        this.updateSavings(variant);
        this.updateDiscountBadges(variant);
      }

      updateSavings(variant) {
        const sectionRoot = this.getSectionRoot();
        const savingsWrap = sectionRoot.querySelector('[data-vc-savings]');
        if (!savingsWrap) return;

        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          const savedAmount = variant.compare_at_price - variant.price;
          const savedPercent = Math.round((savedAmount * 100) / variant.compare_at_price);
          const amountEl = savingsWrap.querySelector('[data-vc-savings-amount]');
          const percentEl = savingsWrap.querySelector('[data-vc-savings-percent]');

          if (amountEl) amountEl.textContent = this.formatMoney(savedAmount);
          if (percentEl) percentEl.textContent = savedPercent;
          savingsWrap.style.display = '';
        } else {
          savingsWrap.style.display = 'none';
        }
      }

      updateDiscountBadges(variant) {
        const sectionRoot = this.getSectionRoot();
        const isOnSale = variant.compare_at_price && variant.compare_at_price > variant.price;
        const discountPercent = isOnSale
          ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100)
          : 0;

        sectionRoot.querySelectorAll('.vc-product__discount-badge').forEach((badge) => {
          if (!isOnSale) {
            badge.style.display = 'none';
            return;
          }
          const percentageElement = badge.querySelector('.vc-product__discount-percentage');
          if (percentageElement) {
            percentageElement.textContent = `${discountPercent}% Off`;
          }
          badge.style.display = 'inline-flex';
        });
      }

      /**
       * 鏇存柊搴撳瓨鐘舵€?
       */
      updateInventory(variant) {
        const sectionRoot = this.getSectionRoot();

        // 鏀寔 VC 浜у搧椤甸潰鐨勫簱瀛樻樉绀?
        const vcStockInfo = sectionRoot.querySelector('.vc-product__stock-info');
        if (vcStockInfo) {
          const indicator = vcStockInfo.querySelector('.vc-product__stock-indicator');
          const text = vcStockInfo.querySelector('.vc-product__stock-text');
          
          if (indicator) {
            indicator.classList.remove('vc-product__stock-indicator--low', 'vc-product__stock-indicator--out');
          }
          
          if (!variant.available) {
            if (indicator) indicator.classList.add('vc-product__stock-indicator--out');
            if (text) text.textContent = 'Out of Stock';
          } else if (variant.inventory_management && variant.inventory_quantity <= 5) {
            if (indicator) indicator.classList.add('vc-product__stock-indicator--low');
            if (text) text.textContent = `Low Stock - Only ${variant.inventory_quantity} left`;
          } else {
            if (text) text.textContent = 'In Stock';
          }
          return;
        }

        // 榛樿搴撳瓨鏄剧ず
        const inventoryEl = sectionRoot.querySelector(`#Inventory-${this.sectionId}, .product__inventory`);
        if (!inventoryEl) return;

        if (!variant.available) {
          inventoryEl.textContent = window.variantStrings?.soldOut || 'Sold out';
          inventoryEl.classList.add('inventory--sold-out');
        } else if (variant.inventory_management && variant.inventory_quantity <= 10) {
          inventoryEl.textContent = `Only ${variant.inventory_quantity} left`;
          inventoryEl.classList.remove('inventory--sold-out');
          inventoryEl.classList.add('inventory--low');
        } else {
          inventoryEl.textContent = window.variantStrings?.inStock || 'In stock';
          inventoryEl.classList.remove('inventory--sold-out', 'inventory--low');
        }
      }

      /**
       * 鏇存柊璐拱鎸夐挳鐘舵€?
       */
      updateBuyButton(variant) {
        const sectionRoot = this.getSectionRoot();
        const button = sectionRoot.querySelector(`#ProductSubmitButton-${this.sectionId}, [type="submit"][name="add"]`);
        if (!button) return;

        const buttonText = button.querySelector('span') || button;

        if (!variant) {
          button.disabled = true;
          buttonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
        } else if (!variant.available) {
          button.disabled = true;
          buttonText.textContent = window.variantStrings?.soldOut || 'Sold out';
        } else {
          button.disabled = false;
          buttonText.textContent = window.variantStrings?.addToCart || 'Add to cart';
        }

        // 鏇存柊 VC 绉诲姩绔?sticky bar 鎸夐挳
        const stickyButton = sectionRoot.querySelector(
          `#vc-sticky-add-to-cart-${this.sectionId}, .vc-product__sticky-button`
        );
        if (stickyButton) {
          if (!variant || !variant.available) {
            stickyButton.disabled = true;
            stickyButton.textContent = window.variantStrings?.soldOut || 'Sold out';
          } else {
            stickyButton.disabled = false;
            stickyButton.textContent = window.variantStrings?.addToCart || 'Add to cart';
          }
        }
      }

      getSectionRoot() {
        return (
          document.getElementById(`MainProduct-${this.sectionId}`) ||
          this.closest(`#MainProduct-${this.sectionId}`) ||
          this.closest('product-info') ||
          document
        );
      }

      publishVariantChange(variant, mediaState = {}) {
        if (typeof publish !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: this.sectionId,
            html: null,
            variant,
            ...mediaState,
          },
        });
      }

      resetMediaFilter(sectionRoot = this.getSectionRoot()) {
        sectionRoot
          .querySelectorAll('.vc-product__thumbnail, .vc-product__dot, [data-thumbnail-id], [data-target]')
          .forEach((element) => {
            element.style.display = '';
            element.hidden = false;
          });
      }

      /**
       * 鏇存柊浜у搧鍥剧墖锛堝垏鎹㈠埌 variant 瀵瑰簲鐨勫浘鐗囩粍锛?
       */
      updateMedia(variant) {
        if (!variant) return { activeMediaId: null, visibleMediaIds: [] };

        const sectionRoot = this.getSectionRoot();
        const rawMappedMediaIds = this.variantMediaMap?.[variant.id];
        const mappedMediaIds = Array.isArray(rawMappedMediaIds)
          ? rawMappedMediaIds.map((id) => String(id))
          : [];
        const fallbackMediaIds =
          mappedMediaIds.length === 0 ? this.findMediaIdsFromDomByVariant(variant, sectionRoot) : [];
        const featuredMediaId = variant.featured_media?.id ? String(variant.featured_media.id) : null;
        const customVideoMediaId = this.productVideo?.videoSrc ? this.productVideo.mediaId : null;
        const visibleMediaIds = [];

        if (customVideoMediaId) {
          visibleMediaIds.push(String(customVideoMediaId));
        }

        if (mappedMediaIds.length > 0) {
          visibleMediaIds.push(...mappedMediaIds);
        } else if (fallbackMediaIds.length > 0) {
          visibleMediaIds.push(...fallbackMediaIds);
        } else if (featuredMediaId) {
          visibleMediaIds.push(featuredMediaId);
        }

        // 鏂规硶 1锛氬鏋滄湁 custom video 鎴?variant-media-map锛屾樉绀鸿 variant 鍏宠仈鐨勬墍鏈夊獟浣?
        const activeMediaId = mappedMediaIds[0] || fallbackMediaIds[0] || featuredMediaId || customVideoMediaId;
        const mediaState = {
          activeMediaId: activeMediaId ? String(activeMediaId) : null,
          visibleMediaIds,
        };
        const vcGallery = sectionRoot.querySelector('vc-media-gallery');

        if (vcGallery && typeof vcGallery.setCustomVideoData === 'function') {
          vcGallery.setCustomVideoData(this.productVideo || null);
        }

        if (visibleMediaIds.length > 0) {
          this.filterMediaByVariant(visibleMediaIds, sectionRoot);
        } else {
          this.resetMediaFilter(sectionRoot);
        }

        // 鏂规硶 2锛氶粯璁よ涓?- 鍒囨崲鍒板綋鍓嶅彉浣撳搴旂殑 custom video 鎴?featured_media
        if (!activeMediaId) return mediaState;

        // VC 浜у搧椤甸潰鐨?media gallery
        if (vcGallery && typeof vcGallery.setActiveMedia === 'function') {
          vcGallery.setActiveMedia(activeMediaId);
          return mediaState;
        }

        // 灏濊瘯涓嶅悓鐨?media gallery 瀹炵幇
        const mediaGallery = sectionRoot.querySelector('media-gallery');
        if (mediaGallery && typeof mediaGallery.setActiveMedia === 'function') {
          mediaGallery.setActiveMedia(`${this.sectionId}-${activeMediaId}`, true);
          return mediaState;
        }

        // 澶囩敤锛氭煡鎵惧甫 data-media-id 鐨勫厓绱?
        const targetMedia = sectionRoot.querySelector(`[data-media-id="${activeMediaId}"]`);
        if (targetMedia) {
          targetMedia.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          const thumbnail =
            sectionRoot.querySelector(`.vc-product__thumbnail[data-media-id="${activeMediaId}"]`) ||
            sectionRoot.querySelector(`[data-thumbnail-id="${activeMediaId}"]`) ||
            sectionRoot.querySelector(`[data-target="${activeMediaId}"]`) ||
            sectionRoot.querySelector(`[data-target="${this.sectionId}-${activeMediaId}"]`);
          if (thumbnail && typeof thumbnail.click === 'function') thumbnail.click();
        }

        return mediaState;
      }

      /**
       * 鏍规嵁 variant ID 杩囨护鏄剧ず鍥剧墖
       * 鍙樉绀轰笌璇?variant 鍏宠仈鐨勫浘鐗?
       */
      filterMediaByVariant(mediaIds, sectionRoot = this.getSectionRoot()) {
        const visibleMediaIds = [...new Set(mediaIds.map((id) => String(id)))];

        if (visibleMediaIds.length === 0) {
          this.resetMediaFilter(sectionRoot);
          return;
        }

        const allThumbnails = sectionRoot.querySelectorAll(
          '.vc-product__thumbnail, .vc-product__dot, [data-thumbnail-id], [data-target]'
        );

        allThumbnails.forEach((thumb) => {
          const rawId = thumb.dataset.mediaId || thumb.dataset.thumbnailId || thumb.dataset.target || '';
          const normalizedId = String(rawId).replace(`${this.sectionId}-`, '');
          const isVisible = visibleMediaIds.includes(normalizedId);

          thumb.style.display = isVisible ? '' : 'none';
          thumb.hidden = !isVisible;
        });
      }

      /**
       * 鏇存柊 SKU 鏄剧ず
       */
      updateSKU(variant) {
        const sectionRoot = this.getSectionRoot();

        // 鏀寔 VC 浜у搧椤甸潰鐨?SKU 鏄剧ず
        const vcSkuEl = sectionRoot.querySelector('.vc-product__item-sku span');
        if (vcSkuEl) {
          vcSkuEl.textContent = variant.sku || 'N/A';
          return;
        }

        // 榛樿 SKU 鏄剧ず
        const skuEl = sectionRoot.querySelector(`#Sku-${this.sectionId}, .product__sku`);
        if (!skuEl) return;

        if (variant.sku) {
          skuEl.textContent = variant.sku;
          skuEl.classList.remove('hidden', 'visibility-hidden');
        } else {
          skuEl.classList.add('visibility-hidden');
        }
      }

      /**
       * 璁剧疆涓轰笉鍙敤鐘舵€侊紙variant 缁勫悎涓嶅瓨鍦級
       */
      setUnavailable() {
        const sectionRoot = this.getSectionRoot();
        // 绂佺敤璐拱鎸夐挳
        const button = sectionRoot.querySelector(`#ProductSubmitButton-${this.sectionId}, [type="submit"][name="add"]`);
        if (button) {
          button.disabled = true;
          const buttonText = button.querySelector('span') || button;
          buttonText.textContent = window.variantStrings?.unavailable || 'Unavailable';
        }

        // 绂佺敤 sticky bar 鎸夐挳
        const stickyButton = sectionRoot.querySelector(
          `#vc-sticky-add-to-cart-${this.sectionId}, .vc-product__sticky-button`
        );
        if (stickyButton) {
          stickyButton.disabled = true;
          stickyButton.textContent = window.variantStrings?.unavailable || 'Unavailable';
        }

        const stickyCompare = sectionRoot.querySelector(
          `#vc-sticky-compare-${this.sectionId}, .vc-product__sticky-price-original`
        );
        if (stickyCompare) {
          stickyCompare.textContent = '';
          stickyCompare.classList.add('hidden');
        }

        const savingsWrap = sectionRoot.querySelector('[data-vc-savings]');
        if (savingsWrap) {
          savingsWrap.style.display = 'none';
        }

        sectionRoot.querySelectorAll('.vc-product__discount-badge').forEach((badge) => {
          badge.style.display = 'none';
        });

        const priceContainer = sectionRoot.querySelector(`#price-${this.sectionId}`) ||
                               sectionRoot.querySelector('.vc-product__price-wrapper .price') ||
                               sectionRoot.querySelector('.product__price, .price');
        if (priceContainer) {
          priceContainer.classList.add('price--sold-out');
        }

        // 绂佺敤 variant input
        const form = sectionRoot.querySelector(`form[id*="${this.sectionId}"], [data-type="add-to-cart-form"]`);
        if (form) {
          const input = form.querySelector('input[name="id"]');
          if (input) input.disabled = true;
        }

        // 鏇存柊搴撳瓨鏄剧ず
        const vcStockInfo = sectionRoot.querySelector('.vc-product__stock-info');
        if (vcStockInfo) {
          const indicator = vcStockInfo.querySelector('.vc-product__stock-indicator');
          const text = vcStockInfo.querySelector('.vc-product__stock-text');
          if (indicator) {
            indicator.classList.remove('vc-product__stock-indicator--low');
            indicator.classList.add('vc-product__stock-indicator--out');
          }
          if (text) text.textContent = 'Unavailable';
        }

        // 鍙戝竷浜嬩欢
        this.dispatchEvent(
          new CustomEvent('variant:unavailable', {
            bubbles: true,
          })
        );
      }

      /**
       * 鏍煎紡鍖栦环鏍?
       * @param {number} cents - 浠锋牸锛堝垎锛?
       * @returns {string} - 鏍煎紡鍖栧悗鐨勪环鏍?
       */
      formatMoney(cents) {
        // 浣跨敤 Shopify 鐨?money_format 鎴栫畝鍗曟牸寮忓寲
        if (window.Shopify && window.Shopify.formatMoney) {
          return window.Shopify.formatMoney(cents);
        }

        const amount = (cents / 100).toFixed(2);
        // 鑾峰彇璐у竵绗﹀彿锛岄粯璁や娇鐢?$
        const currencySymbol = window.Shopify?.currency?.symbol || '$';
        return `${currencySymbol}${amount}`;
      }
    }
  );
}
